<template>
  <p-input-number
    ref="currencyInput"
    v-model="currencyValue"
    :max-fraction-digits="2"
    mode="currency"
    currency="USD"
    locale="en-US"
    fluid
    @keyup.enter="$emit('enter', currencyValue)"
    @blur="emitBlur($event)"
  ></p-input-number>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  autofocus: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:modelValue'])
const currencyValue = computed({
  get () {
    if (props.modelValue && typeof props.modelValue === 'string') {
      return parseFloat(props.modelValue)
    }
    return props.modelValue
  },
  set (v) {
    emit('update:modelValue', v)
  }
})
</script>
